import { render, staticRenderFns } from "./ProductDetailView.vue?vue&type=template&id=583db7f8&scoped=true"
import script from "./ProductDetailView.vue?vue&type=script&lang=js"
export * from "./ProductDetailView.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailView.vue?vue&type=style&index=0&id=583db7f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583db7f8",
  null
  
)

export default component.exports